import * as occlTemplates from './occl';

type TemplatesType = typeof occlTemplates;

export const templates = {
  occl: occlTemplates as unknown as TemplatesType,
};
